import React, { useEffect, useState } from "react";
import { AllCatserviceSection } from "../../FetchAPI";
import APIDataFetchLoader from "../../Others/APIDataFetchLoader";

import CatServiceRows from "./CatServiceRows";
import { useAuth } from "../../../Store/AuthContext";

export default function AllCatServiceTabs({ AllserviceCat }) {
  const { RendomTokenfetch } = useAuth();

  const [activeTab, setActiveTab] = useState("1");
  const [ActiveSerTab, setActiveSerTab] = useState("1");
  // const [ActiveLeads, setActiveLeads] = useState("1");

  const handleCatID = (e, catId) => {
    e.preventDefault();
    setActiveTab(catId); // Update active tab ID
  };
  const handleSerID = (e, serID) => {
    e.preventDefault();
    setActiveSerTab(serID); // Update active tab ID
  };

  const [serviceData, SerCat, loading] = AllCatserviceSection(
    RendomTokenfetch,
    activeTab,
    "5",
    "0"
  );

  // useEffect(() => {
  //   if (serviceData.length > 0) {
  //     setActiveSerTab(serviceData[0].id);
  //   } else {
  //     setActiveSerTab("");
  //   }
  // }, [serviceData]);

  useEffect(() => {
    if (serviceData.length > 0) {
      setActiveSerTab(serviceData[serviceData.length - 1].id); // last one
    } else {
      setActiveSerTab("");
    }
  }, [serviceData]);

  
  if (loading) {
    return <APIDataFetchLoader />;
  }

  return (
    <>
      <div className="container-fluid mt-2 tOTALlEADbOX">
        <ul className="nav nav-tabs" role="tablist">
          {AllserviceCat.length > 0 ? (
            AllserviceCat.map((catData, index) => (
              <li key={index} className="nav-item">
                <a
                  className={`nav-link leadCat ${
                    catData.id === activeTab ? "active" : ""
                  }`}
                  data-bs-toggle="tab"
                  href={`#cat${catData.id}`}
                  onClick={(e) => handleCatID(e, catData.id)}
                >
                  {catData.category}
                </a>
              </li>
            ))
          ) : (
            <div className="noCommnetLead text-center py-3 fw-100">
              No Found!
            </div>
          )}
        </ul>

        {serviceData.length > 0 ? (
          <div className="tab-content">
            <div
              id={`cat${activeTab}`}
              className={`ServiceTabsBox  tab-pane ${
                activeTab === SerCat.catid ? "active" : "fade"
              }`}
            >
              <div className="content CatServicetabs">
                <ul className="nav nav-tabs" role="tablist">
                  {serviceData.length > 0
                    ? serviceData.map((serviceData, index) => (
                        <li key={index} className="nav-item">
                          <a
                            className={`nav-link leadservice ${
                              serviceData.id === ActiveSerTab ? "active" : ""
                            }`}
                            data-bs-toggle="tab"
                            href={`#ser${serviceData.id}`}
                            onClick={(e) => handleSerID(e, serviceData.id)}
                          >
                            {serviceData.title}
                          </a>
                        </li>
                      ))
                    : ""}
                </ul>
              </div>

              <div className="tab-content leaddataBox LeadDatatable">
                {activeTab && ActiveSerTab && (
                  <CatServiceRows catid={activeTab} serid={ActiveSerTab} />
                )}
              </div>
            </div>
          </div>
        ) : (
          <div className="noCommnetLead text-center py-3 fw-100">
            No Services!
          </div>
        )}
      </div>
    </>
  );
}
